import { config } from 'config';
import { useTranslation } from 'libs/i18n';
import { GlobalStyles } from 'libs/ui/styled';

import { ContentStyled } from './LegalClientSigningDocuments.styles';

export const LegalClientSigningDocuments = () => {
  const { t } = useTranslation();

  return (
    <>
      <GlobalStyles
        styles={() => ({
          '.form-content': {
            maxWidth: 'none !important',
          },
        })}
      />
      <ContentStyled
        email={config.EMAIL_ONBOARDING ?? ''}
        text={t('onboarding.legalSigningDocuments.subtitle')}
        title={t('onboarding.legalSigningDocuments.title')}
      />
    </>
  );
};
